import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
    (r) => r,
    async (err) => {
        const orig = err.config || {};
        const url = orig.url || "";
        if (err.response?.status === 401 && !orig._retry && !url.includes("/api/auth/")) {
            orig._retry = true;
            try {
                refreshing = refreshing || api.post("/api/auth/refresh");
                await refreshing;
                refreshing = null;
                return api(orig);
            } catch {
                refreshing = null;
            }
        }
        return Promise.reject(err);
    }
);

export const apiError = (err, fallback = "Κάτι πήγε στραβά. Δοκίμασε ξανά.") => {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (typeof e?.msg === "string" ? e.msg : "")).filter(Boolean).join(" ");
    return fallback;
};

export default api;
